<template>
  <v-content>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
  </v-content>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: process.env.VUE_APP_TTILE
    };
  }
};
</script>